import { Typography, makeStyles } from '@material-ui/core'
import PrimaryTooltip from 'app/componentV4/Tooltip/PrimaryTooltip'
import { FormattedMessage } from 'react-intl'
import React from 'react'
import {
  AutomateCallIcon,
  MessageSpringIcon,
  SmsIcon,
  EmailIcon,
} from 'app/components/icons'
import { useAppName } from 'commons/usePartner'
import { ENABLED_AUTOMATED_CALL } from 'app/constants/compose'
import { usePlace } from 'commons/usePlace'
import { useFormikContext } from 'formik'
import { TYPE_POLL } from 'app/constants/messageType'
import {
  APP_COUNT,
  EMAIL_COUNT,
  SMS_COUNT,
  SUBSCRIBER_COUNT,
  AUTOMATED_CALL_COUNT,
} from 'app/constants/channel'

const useStyles = makeStyles((theme) => ({
  tooltipBox: {
    width: '200px',
    paddingLeft: '8px',
    minHeight: '50px !important',
    verticalAlign: 'middle',
  },
  iconSize: {
    width: '15px !important',
    height: '18px !important',
    paddingTop: '4px',
  },
  notifyMeIconSize: {
    width: '15px !important',
    height: '15px !important',
    paddingTop: '4px',
  },
}))

const SubscriberCount = ({
  subscriberCountState,
  isAutomateCall,
  messageValues,
}) => {
  const classes = useStyles()
  const appName = useAppName()
  const place = usePlace()
  const formik = useFormikContext()
  const isPoll = formik.values.notiType === TYPE_POLL

  return (
    <>
      <PrimaryTooltip
        title={
          <div className={classes.tooltipBox}>
            <div className="flex justify-between">
              <div className="flex">
                <MessageSpringIcon revert={true} notBackground={true} />
                <Typography className="mx-2">{appName} App</Typography>
              </div>
              <Typography className="px-4">
                ({subscriberCountState[APP_COUNT] ?? 0})
              </Typography>
            </div>
            <div className="flex justify-between">
              <div className="flex">
                <EmailIcon revert={true} notBackground={true} />
                <Typography className="mx-2">Email</Typography>
              </div>
              <Typography className="px-4">
                ({subscriberCountState[EMAIL_COUNT] ?? 0})
              </Typography>
            </div>
            <div className="flex justify-between">
              <div className="flex">
                <SmsIcon revert={true} notBackground={true} />
                <Typography className="mx-2">SMS</Typography>
              </div>
              <Typography className="px-4">
                ({subscriberCountState[SMS_COUNT] ?? 0})
              </Typography>
            </div>
            {place[ENABLED_AUTOMATED_CALL] && !isPoll ? (
              <div className="flex justify-between">
                <div className="flex">
                  <AutomateCallIcon revert={true} notBackground={true} />
                  <Typography className="mx-2">Automated Call</Typography>
                </div>
                <Typography className="px-4">
                  ({subscriberCountState[AUTOMATED_CALL_COUNT] ?? 0})
                </Typography>
              </div>
            ) : null}
          </div>
        }
        placement="bottom"
        arrow
      >
        <div className="sm:flex space-x-1">
          <Typography
            className="font-bold text-blue-950"
            data-testid="subscriberCount"
          >
            <FormattedMessage
              id="createNotification.dialog.description.count.subscriber"
              values={{
                subscriberCount: subscriberCountState[SUBSCRIBER_COUNT] ?? 0,
              }}
            />
          </Typography>
          {isAutomateCall && !isPoll && (
            <Typography
              className="font-bold text-blue-950"
              data-testid="automateCall"
            >
              <FormattedMessage
                id="sendMessage.dialog.automatecall.alert.label"
                values={messageValues}
              />
            </Typography>
          )}
        </div>
      </PrimaryTooltip>
    </>
  )
}

export default React.memo(SubscriberCount)
